import { z } from "zod";
import { OrderType } from "@/entities/common/interface/domain/enums";

// OrderType enum/union type for AI tutor session messages
export const OrderTypeSchema = z.nativeEnum(OrderType);

// GetAiTutorSessionMessagesRequestDto validation schema
export const GetAiTutorSessionMessagesRequestDtoSchema = z.object({
    aiTutorSessionId: z.string().min(1, "AI 튜터 세션 ID는 필수입니다"),
    size: z.number().int().positive("양의 정수로만 입력해주세요"),
    orders: OrderTypeSchema,
    nextToken: z.string().optional(),
});

// GetAiTutorSessionsRequestDto validation schema
export const GetAiTutorSessionsRequestDtoSchema = z.object({
    userId: z.string().min(1, "사용자 ID는 필수입니다"),
    size: z.number().int().positive("양의 정수로만 입력해주세요"),
    orders: z.object({
        type: z.string().min(1, "분류 기준은 필수입니다"),
        order: OrderTypeSchema,
    }),
    nextToken: z.string().optional(),
    startDate: z.string().optional(),
    endDate: z.string().optional(),
    bigUnitIds: z.array(z.number()).optional(),
});
